import ecran from '../../../../../core/injectors/ecran.injector';

export default ecran({
    source: 'ac0056',
    ecrans: ['00-2'],
    params:['id', '?daccleint', '?dndrefintnew', '?intnomnew', '?lolcleintnew']
});